import { c as _c } from "react/compiler-runtime";
import { Box, Divider, IconButton, Stack, styled, Typography } from '@mui/material';
import { ScheduleMode, type BackupPolicyConfig, type InventoryBackupPolicy } from '@repo/api-gw-sdk';
import { useState } from 'react';
import { backupPolicyNativeProvider, isMicrosoft365PolicyType, isNativePolicyType } from '@/app/(dashboard)/settings/backup-policies/backupPoliciesTypes';
import { BackupPolicyTypeTag } from '@/app/(dashboard)/settings/backup-policies/backupPolicyTypeTag';
import { isUnlimitedRetention } from '@/app/(dashboard)/settings/controls/retentionText';
import { getFrequencyByWindow, getFrequencyDisplayName } from '@/app/(dashboard)/settings/frequency';
import type { BackupVault } from '@/data/vaults/backupVault';
import { fromDaysToBiggestAsPossible } from '@/utils/dateTime';
import { pluralize } from '@/utils/string';
import { SnapshotIndicator } from '../snapshots/SnapshotIndicator';
import { Tag } from '../tag';
import { BackupVaultCard, VaultCardAsAccount } from '../vaults/backupVaultCard';
const SelectableIconBtn = styled(IconButton)<{
  selected?: boolean;
}>(({
  selected
}) => ({
  border: selected ? `1px solid var(--mui-palette-text-primary)` : 'none',
  padding: '4px',
  margin: selected ? '0 4px' : 'none',
  borderRadius: '50%'
}));
export function BackupPolicyPopperCard(t0) {
  const $ = _c(27);
  const {
    policy,
    vaults
  } = t0;
  let t1;
  if ($[0] !== policy.policyType) {
    t1 = isNativePolicyType(policy.policyType);
    $[0] = policy.policyType;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isNative = t1;
  const [selectedSchedule, setSelectedSchedule] = useState(policy.schedules.length > 0 ? policy.schedules[0] : null);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      backgroundColor: "var(--mui-palette-background-paper)",
      boxShadow: "var(--mui-customShadows-panel)",
      width: "368px",
      padding: "24px",
      paddingBottom: "12px",
      borderRadius: "16px"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      gap: "12px",
      alignItems: "center"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== policy.name) {
    t4 = <Typography variant="h6">{policy.name}</Typography>;
    $[4] = policy.name;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== policy.policyType) {
    t5 = <BackupPolicyTypeTag policyType={policy.policyType} />;
    $[6] = policy.policyType;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== policy.enabled) {
    t6 = !policy.enabled && <Tag content="Disabled" disabled={true} />;
    $[8] = policy.enabled;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = <Stack className="mb-[32px]" direction="row" sx={t3}>{t4}{t5}{t6}</Stack>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== policy || $[15] !== selectedSchedule || $[16] !== vaults) {
    t8 = <PolicyContent policy={policy} vaults={vaults} selectedSchedule={selectedSchedule} />;
    $[14] = policy;
    $[15] = selectedSchedule;
    $[16] = vaults;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== isNative || $[19] !== policy.schedules || $[20] !== selectedSchedule || $[21] !== vaults) {
    t9 = policy?.schedules.length > 1 ? <><Stack direction="row" sx={{
        alignItems: "center",
        justifyContent: "space-between",
        margin: "0 -24px",
        marginTop: "24px",
        padding: "12px 24px",
        paddingBottom: 0,
        borderTop: "1px solid var(--mui-palette-divider)"
      }}><Typography variant="body1">{`${selectedSchedule ? (policy?.schedules.findIndex(p => p.id === selectedSchedule?.id) ?? 0) + 1 : 1} of ${policy?.schedules?.length ?? 0}`}</Typography><Stack direction="row" sx={{
          alignItems: "center",
          gap: "4px"
        }}><IconButton onClick={() => {
            const currentIndex = selectedSchedule ? policy.schedules.findIndex(s => s.id === selectedSchedule.id) : 0;
            setSelectedSchedule(policy.schedules[(currentIndex - 1 + policy.schedules.length) % policy.schedules.length]);
          }}><i className="material-symbols-chevron-left-rounded" /></IconButton>{policy.schedules.map(schedule => {
            const vault = vaults.find(v => v.id === schedule.vaultId);
            const selected = selectedSchedule?.id === schedule.id;
            return <SelectableIconBtn key={schedule.id} selected={selected} onClick={() => {
              if (!selected) {
                setSelectedSchedule(schedule);
              }
            }}><SnapshotIndicator isNative={isNative} backgroundColor={vault?.backgroundColor || null} /></SelectableIconBtn>;
          })}<IconButton onClick={() => {
            const currentIndex_0 = selectedSchedule ? policy.schedules.findIndex(s_0 => s_0.id === selectedSchedule.id) : 0;
            setSelectedSchedule(policy.schedules[(currentIndex_0 + 1) % policy.schedules.length]);
          }}><i className="material-symbols-chevron-right-rounded" /></IconButton></Stack></Stack></> : <div className="mb-[12px]" />;
    $[18] = isNative;
    $[19] = policy.schedules;
    $[20] = selectedSchedule;
    $[21] = vaults;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t10 = <Box onClick={_temp} onMouseDown={_temp2} sx={t2}>{t7}{t8}{t9}</Box>;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(e) {
  return e.stopPropagation();
}
const PolicyContent = t0 => {
  const $ = _c(37);
  const {
    policy,
    vaults,
    selectedSchedule
  } = t0;
  let t1;
  if ($[0] !== policy.policyType) {
    t1 = isNativePolicyType(policy.policyType);
    $[0] = policy.policyType;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isNative = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: "16px"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      alignItems: "start",
      gap: "40px"
    };
    t4 = <Typography className="min-w-[86px]" variant="subtitle1">Frequency</Typography>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      gap: "8px"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = selectedSchedule && getFrequencyByWindow(selectedSchedule.windows)?.text;
  let t7;
  if ($[6] !== t6) {
    t7 = <Typography>{t6}</Typography>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== policy.scheduleMode || $[9] !== selectedSchedule) {
    t8 = policy.scheduleMode === ScheduleMode.SCHEDULE_MODE_ADVANCED && selectedSchedule && <Typography>{getFrequencyDisplayName(selectedSchedule.windows)}</Typography>;
    $[8] = policy.scheduleMode;
    $[9] = selectedSchedule;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7 || $[12] !== t8) {
    t9 = <Stack direction="row" sx={t3}>{t4}<Stack sx={t5}>{t7}{t8}</Stack></Stack>;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Divider sx={{
      borderStyle: "dashed"
    }} />;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      alignItems: "center",
      gap: "40px"
    };
    t12 = <Typography className="min-w-[86px]" variant="subtitle1">Retention</Typography>;
    $[15] = t11;
    $[16] = t12;
  } else {
    t11 = $[15];
    t12 = $[16];
  }
  let t13;
  if ($[17] !== policy.policyType || $[18] !== selectedSchedule) {
    t13 = selectedSchedule?.backupRetention && formatRetention(selectedSchedule.backupRetention, isMicrosoft365PolicyType(policy.policyType));
    $[17] = policy.policyType;
    $[18] = selectedSchedule;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t13) {
    t14 = <Stack direction="row" sx={t11}>{t12}<Typography>{t13}</Typography></Stack>;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Divider sx={{
      borderStyle: "dashed"
    }} />;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  const t16 = isNative ? "Stored in" : "Vault";
  let t17;
  if ($[23] !== t16) {
    t17 = <Typography className="min-w-[86px]" variant="subtitle1">{t16}</Typography>;
    $[23] = t16;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== t14 || $[26] !== t17 || $[27] !== t9) {
    t18 = <Stack sx={t2}>{t9}{t10}{t14}{t15}{t17}</Stack>;
    $[25] = t14;
    $[26] = t17;
    $[27] = t9;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== isNative || $[30] !== policy || $[31] !== selectedSchedule || $[32] !== vaults) {
    t19 = <div className="mt-[16px]">{isNative ? <VaultCardAsAccount cloudProvider={backupPolicyNativeProvider(policy)} region={selectedSchedule?.region || "Source region"} /> : selectedSchedule ? <BackupVaultCard editable={false} data={vaults.find(v => v.id === selectedSchedule.vaultId)} /> : <BackupVaultCard loading={true} editable={false} />}</div>;
    $[29] = isNative;
    $[30] = policy;
    $[31] = selectedSchedule;
    $[32] = vaults;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t18 || $[35] !== t19) {
    t20 = <>{t18}{t19}</>;
    $[34] = t18;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  return t20;
};
const formatRetention = (backupRetention: number, unlimitedSupported: boolean) => {
  if (unlimitedSupported && isUnlimitedRetention(backupRetention)) {
    return 'Unlimited';
  }
  const formattedRetention = fromDaysToBiggestAsPossible(backupRetention);
  return `${formattedRetention.value} ${formattedRetention.unit}${formattedRetention.unit !== 'days' ? ` (${backupRetention} ${pluralize('day', backupRetention)})` : ''}`;
};